var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M20.26 35.58l3.23 26.9a4.82 4.82 0 004.79 4.23h18.45a4.82 4.82 0 004.78-4.24l5.03-41.82H18.46l.63 5.29m11.89 2.02l1.89 31.45m11.15-31.45L42.13 59.4m-9.5-46.1v-.15A4.87 4.87 0 0137.5 8.3s0 0 0 0a4.87 4.87 0 014.87 4.86v.15h-9.74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M15.69 17a3.7 3.7 0 013.7-3.7h36.23a3.7 3.7 0 013.7 3.7s0 0 0 0a3.7 3.7 0 01-3.7 3.7H19.38a3.7 3.7 0 01-3.7-3.7s0 0 0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d92d8094128a0f3b1d78c3bea2a0d8b0.svg";
export { ForwardRef as ReactComponent };